import React from 'react';

function Support() {
    return (
        <div className="support-page">
            <h1>Support Egna Le Egna</h1>
            
            <section className="support-intro">
                <p>
                    In the summer of 2020, a group of passionate college students came together with a common mission: <strong>to provide 100% free mentorship and guidance to first-generation high school students in the Ethiopian and Eritrean communities</strong> across the United States. This initiative, known as Egna Le Egna, was born out of our shared desire to pay forward the support and mentorship we received during our own high school journeys.
                </p>
            </section>

            <section className="support-gofundme">
                <h2>Help Us Become a Non-Profit</h2>
                <p>
                    Over the past three years, we’ve had the privilege of helping over 200 Ethiopian and Eritrean high school students across the USA. We’ve assisted them in gaining admission to highly selective colleges, earning numerous awards, and securing scholarships. Now, we are taking the next step in our journey by working to officially register Egna Le Egna as a 503(c) non-profit organization.
                </p>
                <p>
                    Your support can play a pivotal role in helping us continue and expand our efforts. By contributing to our cause, you are directly empowering first-generation high school students in our communities. <strong>Together, we can help these students overcome challenges, achieve their dreams, and build brighter futures.</strong>
                </p>
                <p>
                    Please consider donating to our GoFundMe campaign to help us cover the registration and administrative costs necessary to become a recognized non-profit organization. Every dollar counts and brings us one step closer to our goal.
                </p>
               <div className="apply-button-container">
                    <a 
                        href="https://www.gofundme.com/f/registering-ele-mentors-as-a-nonprofit?cp_src=d"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="apply-button"
                    >
                        Donate to Our GoFundMe
                    </a>
                </div>
                
            </section>

            <section className="support-volunteer">
                <h2>Volunteer Opportunities</h2>
                <p>
                    We also welcome volunteers who are passionate about supporting our mission. Whether you are a parent, community member, or simply someone who believes in the power of education and mentorship, there are many ways you can contribute:
                </p>
                <ul>
                    <li><strong>Guest Speaking:</strong> Share your experiences and knowledge with our students by volunteering as a guest speaker at one of our workshops or events.</li>
                    <li><strong>Essay Editing:</strong> Help students craft compelling college application essays by offering your skills as an essay editor.</li>
                    <li><strong>Mentorship:</strong> Consider becoming a mentor or providing one-on-one guidance to students in your area of expertise.</li>
                    <li><strong>Workshop Facilitation:</strong> Lead or assist with workshops focused on college preparation, career exploration, and life skills.</li>
                    <li><strong>Resource Development:</strong> Assist in creating and curating educational resources that can benefit our students.</li>
                </ul>
                <p>
                    If you are interested in volunteering, please reach out to us at <a href="mailto:Egnaleegnamentors@gmail.com">Egnaleegnamentors@gmail.com</a> or connect with us on Instagram at <a href="https://www.instagram.com/ele_mentors" target="_blank" rel="noopener noreferrer">@ele_mentors</a>.
                </p>
            </section>

            <section className="support-thankyou">
                <h2>Thank You for Your Support</h2>
                <p>
                    Your generosity and involvement make a meaningful and lasting impact on the lives of the students we serve. Together, we can empower the next generation of Ethiopian and Eritrean leaders.
                </p>
                <p>
                    Thank you for being a part of our mission and for your unwavering support.
                </p>
            </section>
        </div>
    );
}

export default Support;
